import { SliderNotches } from "../SliderBase";
import { useIsTooltipNotches } from "./useIsTooltipNotches.hook";

export const useCalculateArrowVisualStatus = (
  notches: SliderNotches,
  notchText?: string
) => {
  const isTooltipNotches = useIsTooltipNotches(notches);
  if (!isTooltipNotches) return "notdisplayed";
  return notchText ? "visible" : "hidden";
};
